<template>
	<div class="table__block" ref="tableWrap" v-on:scroll="infiniteScroll">
		<div class="table__block-header-checkbox" v-if="flagCheckbox">
			<input type="checkbox" :id="'someCustomHeadCheckbox' + index" :value="'someCustomHeadCheckbox' + index"
				v-model="isAllSelected" @click="selectAllCheckbox">
			<label class="checkbox-label" :for="'someCustomHeadCheckbox' + index">
			</label>
		</div>
		<b-table id="table-transition" :class="{ 'stage-table stage-table--checkbox': data.stageTable }" :items="data.items" :fields="data.fields"
			:borderless="borderless" :selectable="data.selectable ? data.selectable : false" :tbody-tr-class="rowClass"
			select-mode="multi" class="text-nowrap" ref="table" :no-local-sorting="true" :sort-by.sync="sort" :sort-desc.sync="order" @head-clicked="sortClick" @sort-changed="sortingChanged">
			<!-- @sort-changed="sortingChanged"  :sort-by="sort"
			:sort-desc="order"-->
			<!-- :no-local-sorting="data.noLocalSorting" -->
			<!-- This is Lead name as link -->
			<template v-slot:cell(Name)="data">
				<a class="text-nowrap" :href="data.item.hrefProperty" :id="data.item.idName">{{ data.item.Name }}</a>
			</template>

			<!-- This is the (right)arrow that is positioned fixedly on the right side of the table -->
			<template v-slot:cell(icon)="data">
				<a :href="data.item.hrefProperty" :id="data.item.idIconName" class="text-nowrap link"
					@click.prevent="goToMatch(data.item.id, '_self')"
					@mousedown.middle.prevent="goToMatch(data.item.id, '_blank')">
					<SvgIcon class="link_icon" iconName="ico-right" />
				</a>
			</template>

			<!-- This is the (right)arrow that is positioned fixedly on the right side of the table | this is for property to go on single property -->
			<template v-slot:cell(iconProp)="data">
				<!-- <a :href="data.item.hrefProperty" :id="data.item.idIconName" class="text-nowrap link" @click.prevent="singleOrEdit(data.item.id, '_self')" @mousedown.middle.prevent="singleOrEdit(data.item.id,'_blank')"><SvgIcon class="link_icon" iconName="ico-right"/></a> -->
				<a :href="data.item.hrefProperty" :id="data.item.idIconName" class="text-nowrap link"
					@click.prevent="PropertyHistoryOrEdit(data.item.id, '_self')"
					@mousedown.middle.prevent="PropertyHistoryOrEdit(data.item.id, '_blank')">
					<SvgIcon class="link_icon" iconName="ico-right" />
				</a>
			</template>

			<template v-slot:cell(first_name)="data">
				<span>{{ data.item.first_name }}</span>
			</template>

			<!-- This is a picture -->
			<template v-slot:cell(title)="data">
				<div class="img-link text-nowrap" v-if="data.field.flag !== 'match'">
					<a class="img-link__image" :id="data.item.id"
						@click.prevent="PropertyHistoryOrEdit(data.item.id, '_self')"
						@mousedown.middle.prevent="PropertyHistoryOrEdit(data.item.id, '_blank')">
						<div class="table__img" :id="`${'img_' + data.item.thumbnail + '_' + data.item.id}`">
							<img :src="data.item.thumbnail" alt="img" v-if="data.item.thumbnail">
							<img :src="placeholderImg" alt="" v-else>
							<b-popover :target="`${'img_' + data.item.thumbnail + '_' + data.item.id}`" triggers="click"
								:show="!data.item.thumbnail" class="table__img-tooltip" placement="bottomright" boundary="0"
								container="table__block" boundary-padding="0">
								<img :src="data.item.thumbnail" alt="img" v-if="data.item.thumbnail">
							</b-popover>
						</div>
					</a>
					<div class="property-img-cell-wrap">
						<div class="property-img-title property-img__title-box">
							<div class="property-img__inner-title">
								<a :id="data.item.id" @click.prevent="PropertyHistoryOrEdit(data.item.id, '_self')"
									@mousedown.middle.prevent="PropertyHistoryOrEdit(data.item.id, '_blank')">
									{{ data.item.title }}
								</a>
								<span class="table__img-title-tooltip"
									v-if="data.item.title && data.item.title.length > 30">
									{{ data.item.title }}
									<span class="arrow-angle"></span>
								</span>
							</div>
							<a class="btn btn--sm btn--fiord property-img__btn" @click.prevent="redirectToHistory(data)"
								v-if="flagHide">
								Leads
								<!-- <SvgIcon class="property-img__link-icon" iconName="ico-arrow-right" /> -->
							</a>
						</div>
						<a class="property-img__link" target="_blank"
							:href="`${be_link}/custom/download?id=${user.id}&url=${data.item.unpersonalized_pdf_url}`"
							v-if="data.item.unpersonalized_pdf_url && flagHide">
							<span>
								<SvgIcon class="property-img__link-icon" iconName="ico-paperclip" />
							</span>
							<span>Flyer</span>
						</a>
					</div>
				</div>
				<span v-else>
					<!-- <router-link class="img-link text-nowrap" :to="{ name: goInDashboard() ? 'SinglePropertyAdmin' : 'SinglePropertyAgent', params: { id: data.item.id }}"> -->
					<div class="img-link text-nowrap img-link--checkbox">
						<div class="checkbox-wrap" v-if="flagCheckbox">
							<input type="checkbox" :id="data.item.id" :value="data.item.id" v-model="checkedRowsCustomer"
								@change="changeStageMany($event, { customer_id: parseInt($route.params.id), property_id: data.item.id })">
							<label class="checkbox-label" :for="data.item.id">
							</label>
						</div>
						<router-link class="img-link text-nowrap"
							:to="{ name: goInDashboard() ? 'PropertyHistoryAdmin' : 'PropertyHistoryAgent', params: { id: data.item.id } }">
							<div class="table__img" :id="`${'img_' + data.item.thumbnail}`">
								<img :src="data.item.thumbnail" alt="img" v-if="data.item.thumbnail">
								<img :src="placeholderImg" alt="" v-else>
								<b-popover class="table__img-tooltip" :target="`${'img_' + data.item.thumbnail}`"
									triggers="click" :show="!data.item.thumbnail" placement="bottomright" boundary="0"
									container="table__block" boundary-padding="0">
									<img :src="data.item.thumbnail" alt="img" v-if="data.item.thumbnail">
								</b-popover>
							</div>
							<span class="property-img-title">{{ data.item.title }}
								<span class="table__img-title-tooltip"
									v-if="data.item.title && data.item.title.length > 31">
									{{ data.item.title }}
									<span class="arrow-angle"></span>
								</span>
							</span>
						</router-link>
					</div>
				</span>
			</template>

			<!-- History row -->
			<template v-slot:cell(history)="data">
				<a class="history-icon" @click="historyRow(data.item.id)">
					<SvgIcon iconName="ico-exclamation-mark" />
				</a>
			</template>

			<!-- Delete row with star for super admin -->
			<template v-slot:cell(delete_admin)="data">
				<span class="delete-icon is-super-admin" v-if="data.item.role === 'super_admin'">
					<SvgIcon iconName="ico-star" />
				</span>
				<a class="delete-icon" :class="{ 'active-user': user.id === data.item.id }" v-else
					@click="deleteRow(data.item.id)">
					<SvgIcon iconName="ico-delete" />
				</a>
			</template>

			<template v-slot:cell(delete)="data">
				<a class="delete-icon" @click="deleteRow(data.item.id)">
					<SvgIcon iconName="ico-delete" />
				</a>
			</template>

			<template v-slot:cell(delete_history)="data">
				<a class="delete-icon" @click="deleteHistoryRow(data.item)">
					<SvgIcon iconName="ico-delete" />
				</a>
			</template>

			<!-- Clone property icon -->
			<template v-slot:cell(clone_property)="data">
				<a class="copy-icon" @click="cloneProperty(data.item.id)">
					<SvgIcon iconName="ico-copy" />
				</a>
			</template>

			<!-- Edit row icon -->
			<template v-slot:cell(edit)="data">
				<a class="edit-icon" @click.prevent="editRow(data.item.id, '_self')"
					@mousedown.middle.prevent="editRow(data.item.id, '_blank')">
					<SvgIcon iconName="ico-edit" />
				</a>
			</template>

			<!-- Restore row icon -->
			<template v-slot:cell(restore)="data">
				<a class="restore-icon" @click="restoreRow(data.item.id)">
					<SvgIcon iconName="ico-undo" />
				</a>
			</template>

			<!-- Archive row icon -->
			<template v-slot:cell(archive)="data">
				<a class="archive-icon" @click="archiveRow(data.item.id)">
					<SvgIcon iconName="ico-archive-border" />
				</a>
			</template>

			<!-- This is Note -->
			<template v-slot:cell(Note)="data">
				<span class="content-table">
					{{ data.item.Note }}
				</span>
			</template>

			<!-- This is Source -->
			<template v-slot:cell(source)="data">
				<span class="content-table">
					{{ data.item.Source }}
				</span>
			</template>

			<!-- Fields with $ dollar -->
			<template v-slot:cell(regular_price)="data">
				<span v-if="data.item.regular_price">
					${{ formatNumber(data.item.regular_price) }}
				</span>
			</template>

			<!-- Fields with date -->
			<template v-slot:cell(created_at)="data">
				{{ changeDateFormat(data.item.created_at) }}
			</template>

			<template v-slot:cell(updated_at)="data">
				{{ changeDateFormat(data.item.updated_at) }}
				<span v-if="data.field.thClass === 'th-history'">
					- {{ changeTimeFormatZone(data.item.updated_at) }}
				</span>
			</template>

			<template v-slot:cell(from)="data">
				<span v-if="data.item.from.includes(['-', ':'])">
					{{ changeDateFormat(data.item.from) }}
				</span>
				<span v-else>
					{{ data.item.from }}
				</span>
			</template>

			<template v-slot:cell(to)="data">
				<span v-if="data.item.to.includes(['-', ':'])">
					{{ changeDateFormat(data.item.to) }}
				</span>
				<span v-else>
					{{ data.item.to }}
				</span>
			</template>

			<!-- Fields with sf -->
			<template v-slot:cell(building_size)="data">
				<span v-if="data.item.building_size">{{ formatNumber(data.item.building_size) }} SF</span>
			</template>

			<template v-slot:cell(lot_size)="data">
				<span v-if="data.item.lot_size">{{ formatNumber(data.item.lot_size) }} SF</span>
			</template>

			<!-- Property type on properties -->
			<template v-slot:cell(property_type)="data">
				<div class="td-tooltip-list" ref="tdTooltip">
					<span class="tooltip-wrap">
						<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
							<span
								v-if="data.item.property_type_label.length < 2">{{ data.item.property_type_label[0] }}</span>
							<span v-if="data.item.property_type_label.length > 1">Multiple Selection</span>
							<SvgIcon class="tooltip-dots" iconName="ico-ellipsis"
								v-if="data.item.property_type_label.length > 1" />
						</span>
						<span class="tooltip-holder" v-if="toolTips">
							<span class="table-list-item-tooltip" v-if="data.item.property_type_label.length > 1"
								:class="{ 'table-list-item-tooltip--long': data.item.property_type_label.length > 6 }">
								<span v-for="item in data.item.property_type_label" :key="item">
									{{ item }}
								</span>
								<div class="arrow-angle"></div>
							</span>
						</span>
					</span>
				</div>
			</template>

			<template v-slot:cell(offering_type_label)="data">
				<span class="table-list-item" v-for="item in data.item.offering_type_label" :key="item.id">
					{{ item }}
				</span>
			</template>

			<template v-slot:cell(area_label)="data">
				<template v-if="data.item.area_label.length">
					<div class="td-tooltip-list" ref="tdTooltip">
						<span class="tooltip-wrap">
							<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
								<span v-if="data.item.area_label.length < 2">
									<template v-if="data.item.area_label[0] === 'Near Boro Park'">
										<span>Brooklyn</span>
									</template>
									<template v-else-if="data.item.area_label[0] === 'Near Brooklyn'">
										<span>New Jersey</span>
									</template>
									<template v-else>
										<span>{{ data.item.area_label[0] }}</span>
									</template>
								</span>
								<span v-if="data.item.area_label.length > 1">Multiple Selection</span>
								<SvgIcon class="tooltip-dots" iconName="ico-ellipsis"
									v-if="data.item.area_label.length > 1" />
							</span>
							<span class="tooltip-holder" v-if="toolTips">
								<span class="table-list-item-tooltip" v-if="data.item.area_label.length > 1"
									:class="{ 'table-list-item-tooltip--long': data.item.area_label.length > 6 }">
									<span v-for="item in data.item.area_label" :key="item">
										<template v-if="item === 'Near Boro Park'">
											<span>Brooklyn</span>
										</template>
										<template v-else-if="item === 'Near Brooklyn'">
											<span>New Jersey</span>
										</template>
										<template v-else>
											<span>{{ item }}</span>
										</template>
									</span>
									<div class="arrow-angle"></div>
								</span>
							</span>
						</span>
					</div>
				</template>
				<template v-else>
					{{ data.item.area }}
				</template>
			</template>

			<!-- Customers table -->

			<!-- Clone property icon -->
			<template v-slot:cell(clone_customer)="data">
				<a class="copy-icon" @click="cloneCustomer(data.item.id)">
					<SvgIcon iconName="ico-copy" />
				</a>
			</template>

			<template v-slot:cell(critical_note)="data">
				<div class="td-tooltip-wrap">
					<span class="critical_note-text">
						{{ data.item.critical_note }}
					</span>
					<span class="td-tooltip" v-if="data.item.critical_note && data.item.critical_note.length > 64">
						{{ data.item.critical_note }}
						<div class="arrow-angle"></div>
					</span>
				</div>
			</template>
			<template v-slot:cell(note)="data">
				<div class="td-tooltip-wrap">
					<span class="critical_note-text">
						{{ data.item.note }}
					</span>
					<span class="td-tooltip" v-if="data.item.note && data.item.note.length > 64">
						{{ data.item.note }}
						<div class="arrow-angle"></div>
					</span>
				</div>
			</template>
			<!-- Icon End User -->
			<template v-slot:cell(end_user)="data">
				<span v-if="data.item.end_user" class="investor-icon is-investor">
					<SvgIcon iconName="ico-checked" />
				</span>
			</template>

			<template v-slot:cell(last_name_customer)="data">
				<a @click.prevent="goToMatch(data.item.id, '_self')"
					@mousedown.middle.prevent="goToMatch(data.item.id, '_blank')">
					{{ data.item.last_name }} {{ data.item.first_name }}
				</a>
			</template>

			<template v-slot:cell(offering_type_customer)="data">
				<span class="table-list-item" v-for="item in data.item.offering_type_label" :key="item.id">
					{{ item }}
				</span>
			</template>

			<template v-slot:cell(area)="data">
				<div class="td-tooltip-list" ref="tdTooltip">
					<span class="tooltip-wrap">
						<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
							<span v-if="data.item.area_label.length < 2">{{ data.item.area_label[0] }}</span>
							<span v-if="data.item.area_label.length > 1">Multiple Selection</span>
							<SvgIcon class="tooltip-dots" iconName="ico-ellipsis" v-if="data.item.area_label.length > 1" />
						</span>
						<span class="tooltip-holder" v-if="toolTips">
							<span class="table-list-item-tooltip" v-if="data.item.area_label.length > 1"
								:class="{ 'table-list-item-tooltip--long': data.item.area_label.length > 6 }">
								<span v-for="item in data.item.area_label" :key="item">
									{{ item }}
								</span>
								<div class="arrow-angle"></div>
							</span>
						</span>
					</span>
				</div>
			</template>

			<template v-slot:cell(property_type_customer)="data">
				<div class="td-tooltip-list" ref="tdTooltip">
					<span class="tooltip-wrap">
						<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
							<span
								v-if="data.item.property_type_label.length < 2">{{ data.item.property_type_label[0] }}</span>
							<span v-if="data.item.property_type_label.length > 1">Multiple Selection</span>
							<SvgIcon class="tooltip-dots" iconName="ico-ellipsis"
								v-if="data.item.property_type_label.length > 1" />
						</span>
						<span class="tooltip-holder" v-if="toolTips">
							<span class="table-list-item-tooltip" v-if="data.item.property_type_label.length > 1"
								:class="{ 'table-list-item-tooltip--long': data.item.property_type_label.length > 6 }">
								<span v-for="item in data.item.property_type_label" :key="item">
									{{ item }}
								</span>
								<div class="arrow-angle"></div>
							</span>
						</span>
					</span>
				</div>
			</template>

			<template v-slot:cell(building_size_min)="data">
				<span
					v-if="data.item.building_size_min || data.item.building_size_min === 0">{{ formatNumber(data.item.building_size_min) }}
					SF</span>
			</template>

			<template v-slot:cell(building_size_max)="data">
				<span
					v-if="data.item.building_size_max || data.item.building_size_max === 0">{{ formatNumber(data.item.building_size_max) }}
					SF</span>
			</template>

			<template v-slot:cell(lot_size_min)="data">
				<span v-if="data.item.lot_size_min || data.item.lot_size_min === 0">{{ formatNumber(data.item.lot_size_min) }}
					SF</span>
			</template>

			<template v-slot:cell(lot_size_max)="data">
				<span v-if="data.item.lot_size_max || data.item.lot_size_max === 0">{{ formatNumber(data.item.lot_size_max) }}
					SF</span>
			</template>

			<template v-slot:cell(price_min)="data">
				<span v-if="data.item.price_min || data.item.price_min === 0">${{ formatNumber(data.item.price_min) }}</span>
			</template>

			<template v-slot:cell(price_max)="data">
				<span v-if="data.item.price_max || data.item.price_max === 0">${{ formatNumber(data.item.price_max) }}</span>
			</template>

			<!-- Matching tables -->

			<template v-slot:cell(property_shark_link)="data">
				<span>{{ data.item.property_shark_link }}</span>
			</template>

			<template v-slot:cell(property_type_label)="data">
				<div class="td-tooltip-list" ref="tdTooltip">
					<span class="tooltip-wrap">
						<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
							<span
								v-if="data.item.property_type_label.length < 2">{{ data.item.property_type_label[0] }}</span>
							<span v-if="data.item.property_type_label.length > 1">Multiple Selection</span>
							<SvgIcon class="tooltip-dots" iconName="ico-ellipsis"
								v-if="data.item.property_type_label.length > 1" />
						</span>
						<span class="tooltip-holder" v-if="toolTips">
							<span class="table-list-item-tooltip" v-if="data.item.property_type_label.length > 1"
								:class="{ 'table-list-item-tooltip--long': data.item.property_type_label.length > 6 }">
								<span v-for="item in data.item.property_type_label" :key="item">
									{{ item }}
								</span>
								<div class="arrow-angle"></div>
							</span>
						</span>
					</span>
				</div>
			</template>

			<!-- This is a dropdown status with icon-->
			<template v-slot:cell(stage_info)="data">
				<div class="wrapper-dropdown-outher">
					<div class="wrapper-dropdown">
						<span class="dropdown__holder dropdown__holder--read-only"
							:style="{ background: data.item.stage_color, color: stageNameColor(data.item.stage_name) }">
							<template v-if="data.item.stage === 'Lead' && data.item.count > 1">
								{{ data.item.count }} Leads
							</template>
							<template v-else>
								{{ data.item.count }} {{ data.item.stage_name }}
							</template>
						</span>
					</div>
				</div>
			</template>

			<!-- This is a dropdown status with icon-->
			<template v-slot:cell(stage_icon)="data">
				<div class="wrapper-dropdown-outher">
					<div class="wrapper-dropdown" ref="triggerClick" @click="openStagesDrop($event, data.item.id)">
						<span class="dropdown__holder" :id="`${'stage_id_' + data.item.stage + '_' + data.item.id}`"
							:style="{ background: data.item.color, color: stageNameColor(data.item.color) }">
							{{ data.item.stage }}
						</span>
					</div>
					<div class="wrapper-dropdown-notes">
						<div class="date-box">
							<span class="popup-icon" ref="exclamation-mark" @click="showPopupNote(data.item.pivot)">
								<SvgIcon class="link_icon" iconName="ico-exclamation-mark" />
							</span>
						</div>
					</div>
					<!-- Stages dropdown -->
					<b-popover class="dropdown_stages" :show="stagesOpened && choosenStage === data.item.id"
						:target="`${'stage_id_' + data.item.stage + '_' + data.item.id}`" placement="right"
						boundary="scrollParent" container="table__block" boundary-padding="0" triggers="hover">
						<transition name="fade">
							<ul class="dropdown" v-on-click-outside.static="closeStagesDrop">
								<li class="color-picker__item" v-for="stage in allStages" :key="stage.id">
									<a v-if="!isPropertiesMatch()" class="dropdown__link"
										@click="changeStage({ stageRowId: data.item.id, stageRow: data.item.stage, customer_id: parseInt($route.params.id), property_id: data.item.id, stage_id: stage.id, stage_name: stage.title }, stage.title, stage.datepicker)">
										<span class="color-picker__item-color" :style="{ background: stage.color }"></span>
										<span class="color-picker__item-text">
											{{ stage.title }}
										</span>
									</a>
									<a v-else class="dropdown__link"
										@click="changeStage({ stageRowId: data.item.id, stageRow: data.item.stage, property_id: parseInt($route.params.id), customer_id: data.item.id, stage_id: stage.id, stage_name: stage.title }, stage.title, stage.datepicker)">
										<span class="color-picker__item-color" :style="{ background: stage.color }"></span>
										<span class="color-picker__item-text">
											{{ stage.title }}
										</span>
									</a>
								</li>
							</ul>
						</transition>
					</b-popover>
				</div>
			</template>

			<!-- This is the button to send an email -->
			<template v-slot:cell(btn)="data">
				<a class="table-btn" @click="sendEmail(data.item)" :class="{ 'email-sent': data.item.disable_mail_button }"
					v-if="data.item.agent_name !== 'Free Agent'">
					<span class="table-btn-icon-check" v-if="data.item.sentEmailAgain">
						<SvgIcon iconName="ico-checked" />
					</span>
					<span class="table-btn-icon" v-else>
						<SvgIcon iconName="ico-email" />
					</span>
					<span class="table-btn-text" v-if="data.item.sentEmailAgain">Sent</span>
					<span class="table-btn-text" v-else>Send Email</span>
				</a>
			</template>

			<template v-slot:cell(date_listed)="data">
				{{ changeDateFormat(data.item.date_listed) }}
			</template>

			<template v-slot:cell(date_verified)="data">
				{{ changeDateFormat(data.item.date_verified) }}
			</template>

			<template v-slot:cell(verification_overdue)="data">
				<a class="overdue-wrap" v-if="data.item.verification_overdue">
					<span class="overdue-icon" :style="{ background: data.item.verification_color_code }"></span>
					<span class="overdue-val">{{ data.item.verification_overdue }}</span>
					<span class="overdue-month" v-if="data.item.verification_overdue === 1">month</span>
					<span class="overdue-month" v-else>months</span>
				</a>
			</template>

			<template v-slot:cell(delete-stage)="data">
				<a class="delete-icon" @click="dismissStage(data.item.pivot)"
					v-if="!data.item.stage.includes('Dismissed System')">
					<SvgIcon iconName="ico-delete" />
				</a>
			</template>

			<template v-slot:cell(last_name)="data">
				<span class="checkbox-wrap-holder" v-if="data.field.flag === 'match'">
					<div class="checkbox-wrap--clasic" v-if="flagCheckbox">
						<input type="checkbox" :id="data.item.id" :value="data.item.id" v-model="checkedRowsCustomer"
							@change="changeStageMany($event, { property_id: parseInt($route.params.id), customer_id: data.item.id })">
						<label class="checkbox-label" :for="data.item.id">
						</label>
					</div>
					<router-link
						:to="{ name: goInDashboard() ? 'SingleCustomerPropertiesAdmin' : 'SingleCustomerPropertiesAgent', params: { id: data.item.id } }">
						{{ data.item.last_name }} {{ data.item.first_name }}
					</router-link>
				</span>
				<span v-else>
					{{ data.item.last_name }}
				</span>
			</template>

			<template v-slot:cell(property_name)="data">
				<!-- <router-link class="img-link text-nowrap" :to="{ name: goInDashboard() ? 'SinglePropertyAdmin' : 'SinglePropertyAgent', params: { id: data.item.id}}"> -->
				<router-link class="img-link text-nowrap"
					:to="{ name: goInDashboard() ? 'PropertyHistoryAdmin' : 'PropertyHistoryAgent', params: { id: data.item.id } }">
					<div class="table__img">
						<img :src="data.item.thumbnail" alt="img" v-if="data.item.thumbnail">
						<img :src="placeholderImg" alt="" v-else>
					</div>
					<span class="property-img-title">{{ data.item.title }}
						<span class="table__img-title-tooltip" v-if="data.item.title && data.item.title.length > 31">
							{{ data.item.title }}
							<span class="arrow-angle"></span>
						</span>
					</span>
				</router-link>
			</template>

			<template v-slot:cell(verification_notification_date)="data">
				{{ changeDateFormat(data.item.verification_notification_date) }}
				<span v-if="data.item.verification_notification_date">
					- {{ changeTimeFormat(data.item.verification_notification_date) }}
				</span>
			</template>

			<!-- New prices -->
			<template v-slot:cell(price_buildable_sf)="data">
				<span
					v-if="data.item.price_buildable_sf || data.item.price_buildable_sf === 0">${{ formatNumber(data.item.price_buildable_sf) }}</span>
			</template>

			<template v-slot:cell(price_psf)="data">
				<span v-if="data.item.price_psf || data.item.price_psf === 0">${{ formatNumber(data.item.price_psf) }}</span>
			</template>

			<template v-slot:cell(lease_price)="data">
				<span
					v-if="data.item.lease_price || data.item.lease_price === 0">${{ formatNumber(data.item.lease_price) }}</span>
			</template>

			<template v-slot:cell(yearly_price)="data">
				<span
					v-if="data.item.show_yearly_price && (data.item.yearly_price || data.item.yearly_price === 0)">${{ formatNumber(data.item.yearly_price) }}</span>
			</template>

			<template v-slot:cell(price_psf_min)="data">
				<span
					v-if="data.item.price_psf_min || data.item.price_psf_min === 0">${{ formatNumber(data.item.price_psf_min) }}</span>
			</template>

			<template v-slot:cell(price_psf_max)="data">
				<span
					v-if="data.item.price_psf_max || data.item.price_psf_max === 0">${{ formatNumber(data.item.price_psf_max) }}</span>
			</template>

			<template v-slot:cell(price_buildable_sf_max)="data">
				<span
					v-if="data.item.price_buildable_sf_max || data.item.price_buildable_sf_max === 0">${{ formatNumber(data.item.price_buildable_sf_max) }}</span>
			</template>

			<template v-slot:cell(price_buildable_sf_min)="data">
				<span
					v-if="data.item.price_buildable_sf_min || data.item.price_buildable_sf_min === 0">${{ formatNumber(data.item.price_buildable_sf_min) }}</span>
			</template>

			<template v-slot:cell(lease_price_max)="data">
				<span
					v-if="data.item.lease_price_max || data.item.lease_price_max === 0">${{ formatNumber(data.item.lease_price_max) }}</span>
			</template>

			<template v-slot:cell(lease_price_min)="data">
				<span
					v-if="data.item.lease_price_min || data.item.lease_price_min === 0">${{ formatNumber(data.item.lease_price_min) }}</span>
			</template>

			<template v-slot:cell(yearly_price_min)="data">
				<span
					v-if="data.item.yearly_price_min || data.item.yearly_price_min === 0">${{ formatNumber(data.item.yearly_price_min) }}</span>
			</template>

			<template v-slot:cell(yearly_price_max)="data">
				<span
					v-if="data.item.yearly_price_max || data.item.yearly_price_max === 0">${{ formatNumber(data.item.yearly_price_max) }}</span>
			</template>

			<!-- Lead Dashboard arrow -->
			<template v-slot:cell(iconArrow)="data">
				<router-link v-if="data.field.flag === 'leadProperties'"
					:to="{ name: goInDashboard() ? 'SinglePropertyAdmin' : 'SinglePropertyAgent', params: { id: data.item.id } }"
					class="text-nowrap link">
					<SvgIcon class="link_icon" iconName="ico-right" />
				</router-link>
				<router-link v-else-if="data.field.flag === 'leadCustomers'"
					:to="{ name: goInDashboard() ? 'SingleCustomerPropertiesAdmin' : 'SingleCustomerPropertiesAgent', params: { id: data.item.id } }"
					class="text-nowrap link">
					<SvgIcon class="link_icon" iconName="ico-right" />
				</router-link>
			</template>

		</b-table>
		<BlockFormPopup v-if="activePopup" :class="{ 'active': activePopup }" :data="popupData" class="popups-content"
			@closePopupForm="closePopupForm" @submitForm="submitForm" />
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { formatNumber, formatDate, formatTime, formatTimeZone, getDemoAsset } from '@/config/util';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import BlockFormPopup from '@/components/blocks/BlockFormPopup';
import { BPopover } from 'bootstrap-vue';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		// sort: {
		// 	type: String,
		// 	required: false
		// },
		// order: {
		// 	type: Boolean
		// },
		index: {
			required: false
		},
		flagCheckbox: {
			required: false
		},
		flagHide: {
			required: false
		},
		getPage: {
			required: false
		},
		total: {
			required: false
		}
	},
	components: {
		SvgIcon,
		BlockFormPopup,
		BPopover
	},
	data() {
		return {
			order: false,
			isAllSelected: false,
			checkedRowsCustomer: [],
			show: false,
			toolTips: true,
			rowSelection: [],
			noCollapse: false,
			borderless: true,
			activePopup: false,
			showTooltip: false,
			popupData: {
				popupId: 'popup_emailed',
				popupTitle: '',
				DataNoteArea: {
					label: 'Notes',
					inputId: 'note-popup-input',
					labelId: 'note-popup-label',
					classTextarea: 'small-area'
				},
				showCalendar: false,
				DataCalendar: {
					label: '',
					inputId: 'date_calendar-input',
					labelId: 'date_calendar-label',
					icon: true
				}
			},
			stickyHeader: true,
			active: '',
			placeholderImg: getDemoAsset('property/placeholder-50x50.png'),
			assStageObj: null,
			stagesOpened: false,
			choosenStage: null,
			classScroll: 'prevent-scroll',
			whiteTextBg: [
				'#9C27B0', '#673AB7', '#4054B2', '#795548', '#7A869A', '#607D8B', '#9E9E9E', '#000000', '#42526E', '#2684FF'
			]
		};
	},
	watch: {
		currentSelected() {
			if (this.data.items[0]) {
				if (this.currentSelected.name !== this.data.items[0].stage) {
					this.checkedRowsCustomer = [];
					this.isAllSelected = false;
				}
			}
		},
		data() {
			this.$forceUpdate();
		}
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		allStages() {
			return this.$store.getters.getStages;
		},
		be_link() {
			return process.env.VUE_APP_BACKEND_URL;
		},
		currentSelected() {
			return this.$store.getters.getCurrentSelected;
		},
		sort() {
			if (this.data.fields.length > 0) {
				if (this.data.defaultOrderBy && this.data.defaultOrderBy === 'date_listed') {
					return 'date_listed';
				}
				return this.data.fields[0].key;
			}
			return '';
		}
	},
	mounted() {
		if (this.data.defaultOrderBy && this.data.defaultOrderBy === 'date_listed') {
			this.order = true;
		}

		document.querySelector('#table-transition').addEventListener('scroll', function (e) {
			this.choosenStage = null;
			this.stagesOpened = false;
			document.querySelectorAll('.b-popover').forEach(element => {
				element.blur();
			});
		});

		const container = document.querySelector('.table__block');
		const rows = container.querySelectorAll('tr');
		if (container && rows) {
			container.addEventListener('scroll', () => {
				const containerRect = container.getBoundingClientRect();

				rows.forEach((row) => {
					const rect = row.getBoundingClientRect();
					const isVisible =
						rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

					if (isVisible) {
						row.classList.remove('hidden-row');
					} else {
						row.classList.add('hidden-row');
					}
				});
			});
		}
		this.$refs.tableWrap.addEventListener('scroll', this.infiniteScroll);
	},
	unmounted() {
		this.$refs.tableWrap.removeEventListener('scroll', this.infiniteScroll);
	},
	beforeMount() {
		// this.mobileTooltip();
	},
	mixins: [onClickOutside],
	destroyed() {
		this.$store.dispatch('setCurrentSelected', { name: '', color: '', id: '' });
	},
	methods: {
		selectAllCheckbox() {
			this.checkedRowsCustomer = [];
			const item = this.allStages.find(ele => ele.title === this.data.items[0].stage);
			this.$store.dispatch('setCurrentSelected', { name: item.title, color: item.color, id: item.id });

			if (!this.isAllSelected) {
				this.data.items.forEach(row => {
					this.checkedRowsCustomer.push(row.id);
					if (this.data.history) {
						this.$store.dispatch('setCustomPropertiesChangeStage', {
							property_id: parseInt(this.$route.params.id),
							customer_id: row.id
						});
					} else {
						this.$store.dispatch('setCustomPropertiesChangeStage', {
							customer_id: parseInt(this.$route.params.id),
							property_id: row.id
						});
					}
				});
			} else {
				if (this.data.history) {
					this.data.items.forEach(row => {
						this.$store.dispatch('removeCustomPropertiesChangeStage', {
							property_id: parseInt(this.$route.params.id),
							customer_id: row.id
						});
					});
				} else {
					this.data.items.forEach(row => {
						this.$store.dispatch('removeCustomPropertiesChangeStage', {
							customer_id: parseInt(this.$route.params.id),
							property_id: row.id
						});
					});
				}
			}
			this.isAllSelected = !this.isAllSelected;
			this.$store.dispatch('actionIsAllSelected', this.isAllSelected);
			this.$store.dispatch('actionIsAllSelectedProperty', this.isAllSelected);

			this.$store.dispatch('actionTotalSelectedInStage', {
				component: this.isAllSelected ? 'BlockTable' : null,
				total: this.isAllSelected ? this.total : 0
			});
		},
		changeStageMany(e, obj) {
			if (this.data.items[0].stage !== this.currentSelected.name) {
				const item = this.allStages.find(ele => ele.title === this.data.items[0].stage);
				this.$store.dispatch('setCurrentSelected', { name: item.title, color: item.color, id: item.id });
			}

			const { checked } = e.target;
			(checked) ? this.$store.dispatch('setCustomPropertiesChangeStage', obj) : this.$store.dispatch('removeCustomPropertiesChangeStage', obj);
			this.$store.dispatch('updateTotalSelectedInStage', checked);

			if (this.checkedRowsCustomer.length === 0) {
				this.isAllSelected = false;
			}
			if (this.checkedRowsCustomer.length === this.data.items.length) {
				this.isAllSelected = true;
			}
		},
		togglePopup(id) {
			return this.stagesOpened && this.choosenStage === id;
		},
		sortingChanged(e) {
			this.$emit('onSort', e.sortBy, (e.sortDesc) ? 'desc' : 'asc');
			this.$refs.tableWrap.scrollTo({ top: 0 });
		},
		rowClass(item, type) {
			return item.listing_status === 'in-contract' ? 'yellowbg' : '';
		},
		mobileTooltip() {
			if (window.innerWidth <= 640) {
				this.toolTips = false;
			}
		},
		isMobile() {
			if (this.toolTips !== true) {
				this.toolTips = true;
			} else {
				this.toolTips = false;
			}
		},
		openStagesDrop(e, id) {
			// e.target.parentElement.parentElement.parentElement.classList.add('opened-td');
			this.stagesOpened = true;
			this.choosenStage = id;
		},
		closeStagesDrop() {
			// document.querySelector('.opened-td').classList.remove('opened-td');
			this.stagesOpened = false;
			this.choosenStage = null;
		},
		infiniteScroll(e) {
			if (this.$refs.tableWrap.scrollTop + this.$refs.tableWrap.clientHeight + 200 >= this.$refs.tableWrap.scrollHeight) {
				this.$emit('getPage');
			}

			// if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 400) {
			// 	this.$emit('loadMore');
			// }
			// this.choosenStage = null;
			// this.stagesOpened = false;
		},
		isPropertiesMatch() {
			return this.$route.fullPath.includes('properties');
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		redirectToHistory(data) {
			const routePropertyHistoryOrEdit = this.$router.resolve({ path: '/properties/history/' + data.item.id });
			window.open(routePropertyHistoryOrEdit.href, '_self');
		},
		PropertyHistoryOrEditCustomer(id, target) {
			const routePropertyHistoryOrEdit = this.$router.resolve({ name: this.goInDashboard() ? 'EditCustomerAdmin' : 'EditCustomerAgent', params: { id: id } });
			window.open(routePropertyHistoryOrEdit.href, target);
		},
		// Set Property in dismiss stage
		dismissStage(pivot) {
			let stageId;
			let stageName;
			this.allStages.forEach(stage => {
				if (stage.title.includes('Dismissed System') || stage.title.includes('Dismissed system')) {
					stageId = stage.id;
					stageName = stage.title;
				}
			});

			const obj = {
				customer_id: pivot.customer_id,
				property_id: pivot.property_id,
				stage_id: stageId,
				stage_name: stageName,
				history: [
					{
						body: '',
						stage: stageName,
						popup_date: ''
					}
				]
			};
			this.$emit('dismissStage', obj);
		},
		changeStage(obj, title, datepicker) {
			this.popupData.popupTitle = title;
			this.popupData.showCalendar = datepicker;
			this.activePopup = true;
			this.assStageObj = obj;
			this.$refs.tableWrap.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
		},
		submitForm(data) {
			const obj = {
				customer_id: this.assStageObj.customer_id,
				property_id: this.assStageObj.property_id,
				stage_id: this.assStageObj.stage_id,
				stage_name: this.assStageObj.stage_name,
				stageRow: this.assStageObj.stageRow,
				stageRowId: this.assStageObj.stageRowId,
				history: [
					{
						body: data.note,
						stage: this.assStageObj.stage_name,
						popup_date: data.datepicker
					}
				]
			};
			this.$store.dispatch('resetCustomerSelectAll', false);
			this.$emit('updateStage', obj);
			this.closePopupForm();
		},
		closePopupForm() {
			this.activePopup = false;
			this.$refs.tableWrap.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
		},
		deleteRow(id) {
			this.$emit('deleteRow', id);
		},
		deleteHistoryRow(id) {
			this.$emit('deleteHistoryRow', id);
		},
		historyRow(id) {
			this.$emit('historyRow', id);
		},
		restoreRow(id) {
			this.$emit('restoreRow', id);
		},
		archiveRow(id) {
			this.$emit('archiveRow', id);
		},
		editRow(id, target) {
			this.$emit('editRow', id, target);
		},
		PropertyHistoryOrEdit(id, target) {
			this.$emit('PropertyHistoryOrEdit', id, target);
		},
		goToMatch(id, target) {
			this.$emit('goToMatch', id, target);
		},
		formatNumber(field) {
			return formatNumber(field);
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		changeTimeFormat(date) {
			return formatTime(date);
		},
		changeTimeFormatZone(date) {
			return formatTimeZone(date);
		},
		sortClick(item) {
			this.$emit('sortData', item);
		},
		showPopupNote(pivot) {
			this.$emit('showPopupNote', pivot);
		},
		cloneProperty(id) {
			this.$emit('cloneProperty', id);
		},
		cloneCustomer(id) {
			this.$emit('cloneCustomer', id);
		},
		sendEmail(item) {
			this.$emit('sendEmail', item);
		},
		stageNameColor(bg) {
			return this.whiteTextBg.includes(bg) ? '#fff' : '#000';
		}
	}
};
</script>

<style lang="scss">
.b-popover[x-out-of-boundaries] {
	display: none;
}

.text-nowrap.b-table-sticky-header.table-responsive {
	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}

	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;
}

.slimScrollBarHorizontal {
	background: $fiord;
	width: 51px;
	position: absolute;
	bottom: 5px;
	border-radius: 7px;
	z-index: 999;
	left: 1px;
	height: 7px;
}

.popups-content {
	visibility: hidden;
	backface-visibility: hidden;
	transition: $dur $ease;
	opacity: 0;

	&.active {
		opacity: 1;
		transition: $dur $ease;
		visibility: visible;
	}
}

.popup-icon {
	cursor: pointer;
}

.info-popup {
	padding: 24px 20px;
	position: absolute;
	z-index: 1003;
	background: $white;
	box-shadow: 0 2px 4px $black;
	border-radius: 8px;
	width: 476px;
	min-height: 193px;
	left: 85%;
	opacity: 0;
	pointer-events: none;
}

.popup-title {
	font-family: $font-second;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: $fiord;
	margin-bottom: 26px;
}

.popup-label {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
	opacity: 0.5;
	margin-bottom: 7px;
}

.popup-content {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
}

.table-date-icon {
	z-index: 5 !important; //sass-lint:disable-line no-important;
}

.property-img-title {
	display: -webkit-box;
	max-width: 103px;
	height: 100%;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 20px;
	max-height: 41px;

	&:hover {
		.table__img-title-tooltip {
			opacity: 0 !important;
			visibility: hidden !important;
		}
	}
}

.property-img__inner-title {
	@include mq($sm) {
		margin-bottom: 10px;
	}

	a {
		max-width: 50%;
		max-height: 40px;

		@include hover {
			color: $dodger-blue !important;
		}
	}

	&:hover {
		.table__img-title-tooltip {
			opacity: 1 !important;
			visibility: visible !important;
		}
	}
}

.critical_note-text {
	&:hover {
		.td-tooltip {
			opacity: 1;
			visibility: visible;
		}
	}
}

.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 5px 12px 8px;
	border-color: transparent transparent #fff transparent;
	top: 0;
	position: absolute;
	left: -9px;
	transform: rotate(-90deg) translateX(-50%);
	box-shadow: 1px 1px 15px -5px #000;
	z-index: 8;
}

.table__img-title-tooltip {
	box-shadow: 1px 1px 15px -5px $black;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 100%;
	width: 100%;
	font-size: 12px;
	background-color: $white;
	border-radius: 8px;
	padding: 5px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.75s ease;
	font-family: $font-main;
	line-height: 1.2;
	text-align: left;
	max-width: fit-content;
	color: $fiord;
	z-index: 9;
	pointer-events: none;

	@include mq($sm) {
		left: 105%;
	}
}

.table-responsive {
	margin-bottom: 0;
}

/*--------------------------------------------------------------
## table basic view
--------------------------------------------------------------*/
.table__block {
	// max-width: 1255px;
	position: relative;

	.table-select-all {
		padding: 5px !important; //sass-lint:disable-line no-important;
	}
}

/*--------------------------------------------------------------
## btn in table
--------------------------------------------------------------*/
.table-btn {
	display: inline-block;
	text-align: center;
	color: $white;
	padding: 8px 10px;
	outline: none;
	max-width: 123px;
	width: 100%;
	transition: $dur $ease;
	cursor: pointer;
	background-color: $dodger-blue;
	border-radius: 8px;
	border: 1px solid $dodger-blue;
	position: relative;
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 1.1;
	transition: $dur $ease;

	@include hover {
		background-color: $white;

		.table-btn-text {
			color: $dodger-blue;
		}
	}

	&.sent-email {
		background-color: $shuttle-gray;
	}
}

/*--------------------------------------------------------------
## color picker
--------------------------------------------------------------*/
.dropdown__holder {
	padding: 3px 27px 3px 10px;
	cursor: pointer;
	position: relative;
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	max-width: 140px;
	min-width: 80px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
	transition: $dur $ease;
	border-radius: 8px;
	color: $white !important;

	@include mq(440px) {
		min-width: 65px;
		padding: 3px 20px 3px 10px;
	}

	&::after,
	&::before {
		border-right: 2px solid;
		content: '';
		display: block;
		height: 5px;
		margin-top: -4px;
		position: absolute;
		transform: rotate(135deg);
		right: 10px;
		top: 50%;
		width: 0;
	}

	&::after {
		margin-top: -1px;
		transform: rotate(45deg);
	}

	&.dropdown__holder--read-only {
		padding: 3px 10px 3px 10px;

		&::after,
		&::before {
			display: none;
		}
	}
}

.wrapper-dropdown {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-right: 10px;
	transition: $dur $ease;

	@include hover {
		.dropdown__holder {
			opacity: 0.8;
		}
	}
}

.color-picker__item {
	display: flex;
	align-items: center;
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
	margin-bottom: 10px;
	cursor: pointer;
	transition: $dur $ease;

	@include mq($md) {
		font-size: 12px;
		margin-bottom: 5px;
	}
}

.color-picker__item-color {
	width: 12px;
	min-width: 12px;
	height: 12px;
	display: block;
	border-radius: 50%;

	@include mq(440px) {
		width: 10px;
		min-width: 10px;
		height: 10px;
	}
}

.dropdown__link {
	display: flex;
	align-items: center;
	max-width: 100%;

	.color-picker__item-text {
		width: auto;
		height: auto;
		padding-left: 18px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		@include mq($xl) {
			padding-left: 10px;
		}

		@include mq(512px) {
			padding-left: 0;
		}
	}

	@include hover {
		.color-picker__item-text {
			color: $dodger-blue;
		}
	}
}

.head-checkbox-wrap {
	display: flex;
}

.head-checkbox__label {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	align-items: center;
	color: $white;

	@include mq($sm) {
		font-size: 13px;
	}
}

.table-list-item {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: space-between;
}

.table-list-item-has-tooltip {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.wrapper-dropdown-outher {
	display: flex;
	justify-content: space-between;
}

.email-sent {
	opacity: .5;
}

tr.yellowbg td {
	background-color: #FFFCF0 !important; //sass-lint:disable-line no-important;
	background: #FFFCF0 !important; //sass-lint:disable-line no-important;
}

.img-link--checkbox {
	position: relative;

	.checkbox-wrap {
		position: absolute;
		left: 14px;
		display: block;
		padding: 0;
		background-color: transparent;
	}

	.checkbox-wrap__label {
		padding-left: 31px;
	}

	.table__img {
		border-radius: 7px;
		overflow: hidden;
		background-color: #B8BECC;
	}
}

.table-property__checkbox {
	display: flex;
	align-items: center;

	.checkbox-wrap {
		z-index: 10;
	}
}

.checkbox-wrap-holder {
	display: flex;
	align-items: center;
}

.checkbox-wrap--clasic {
	position: relative !important;
	width: 18px;
	height: 18px;
	margin-right: 17px;

	.checkbox-label {
		position: absolute !important;
		top: 0;
		left: 0;
	}
}</style>
